<template>
  <div class="row formJov">
    <div class="col-lg-12">
      <span class="ml-3 f14 font-weight-bold">TÍTULO DA PROVA</span>
      <inputform
        v-model="evaluation_edit.name"
        type="text"
        :field="$v.evaluation_edit.name"
        class="label-bold mt-2"
      />
    </div>
    <div class="col-lg-12">
      <span class="ml-3 f14 font-weight-bold">DESCRIÇÃO</span>
      <ckeditor
        v-model="evaluation_edit.description"
        class="mt-2"
        :class="{
                'is-invalid': $v.evaluation_edit.description.$error,
                'is-valid': !$v.evaluation_edit.description.$invalid,
              }"
      />
    </div>

    <div class="col-lg-12 mt-3">
      <span 
        class="ml-3 f14 font-weight-bold"
      >
        EM QUAL ETAPA ESTÁ PERGUNTA IRÁ:
      </span>
      <select
        v-model="evaluation_edit.selective_process_id"
        class="form-control col-xl-12"
        style="text-transform: uppercase"
      >
        <option
          class="form-control"
          v-for="selective_process in selective_processes"
          :key="selective_process.id"
          :value="selective_process.id"
        >
          {{ selective_process.name }}
        </option>
      </select>
    </div>

    <div class="col-lg-12 mt-3">
      <button
        @click="save"
        class="btn btn-primary full radius-0 f13 h-100"
      >
        Salvar
      </button>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  props: {
    job_id: {
      type: Number,
      required: true,
    },
    evaluation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      evaluation_edit: {
        id: null,
        name: "",
        description: "",
      },
      selective_processes: [],
      default_process_id: null,
    };
  },
  mounted() {
    this.evaluation_edit.name = this.evaluation.name;
    this.evaluation_edit.id = this.evaluation.id;
    this.evaluation_edit.description = this.evaluation.description;
    this.$root.$on("columnsChanged", (selective_processes) => {
      this.selective_processes = selective_processes;
      this.default_process_id = selective_processes.filter(
        (process) => process.status === 1
      )[0].id;
      this.evaluation_edit.selective_process_id = this.evaluation.selective_process_id ?
        this.evaluation.selective_process_id :
        this.default_process_id;
    });
  },
  methods: {
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      if (this.evaluation_edit.id) {
        axios
          .put("/recruiters/evaluations/" + this.evaluation_edit.id, {
            evaluation: {
              name: this.evaluation_edit.name,
              description: this.evaluation_edit.description,
              job_id: this.job_id,
              selective_process_id: this.evaluation_edit.selective_process_id,
            },
          })
          .then(() => {
            this.$toast.success("Prova atualizada com sucesso!");
          });
      } else {
        axios
          .post("/recruiters/evaluations", {
            evaluation: {
              name: this.evaluation_edit.name,
              description: this.evaluation_edit.description,
              job_id: this.job_id,
              selective_process_id: this.evaluation_edit.selective_process_id,
            },
          })
          .then(() => {
            this.$toast.success("Prova criada com sucesso!");
          });
      }
    },
  },
  validations: {
    evaluation_edit: {
      name: {
        required,
      },
      description: {
        required,
      },
    },
  },
};
</script>
